export default {
  // común
  ok: 'Aceptar',
  cancel: 'Cancelar',
  send: 'Enviar',
  // tiempo
  timeJustNow: 'Ahora mismo',
  timeMinutesAgo: 'hace {n} min',
  timeHoursAgo: 'hace {n} h',
  timeYesterday: 'Ayer',
  // títulos de la barra de herramientas del chat
  chatEmotion: 'Emoji',
  chatSendImage: 'Enviar imagen',
  chatSendFile: 'Enviar archivo',
  chatReceipt: 'Mensaje con acuse',
  chatSendVoice: 'Enviar voz',
  chatGroupInfo: 'Información del grupo',
  // área de chat
  chatSomeoneAtMe: 'Alguien me mencionó',
  chatNewMessages: '{n} mensajes nuevos',
  chatBackToBottom: 'Volver al final',
  chatReceiptPrefix: '[Acuse] ',
  // acciones / avisos de mensajes
  chatNoMoreMessages: 'No hay más mensajes',
  chatDeleteConfirm: '¿Eliminar este mensaje?',
  chatDeleteTitle: 'Eliminar mensaje',
  chatRecallConfirm: '¿Retirar este mensaje?',
  chatRecallTitle: 'Retirar mensaje',
  chatRecalled: 'Mensaje retirado',
  chatLocateFail: 'No se puede localizar el mensaje original',
  chatResendUnsupported: 'Este mensaje no admite reenvío automático. Vuelve a enviarlo manualmente.',
  // avisos de entrada deshabilitada
  chatGroupDissolved: 'El grupo ha sido disuelto',
  chatGroupQuit: 'Ya no perteneces a este grupo',
  chatGroupBanned: 'El grupo ha sido bloqueado',
  chatUserBanned: 'Esta cuenta ha sido bloqueada',
  chatBanReason: ', motivo: ',
  // estado / lectura de mensajes
  msgReaded: 'Leído',
  msgUnread: 'No leído',
  msgAllReaded: 'Todos leídos',
  msgSomeReaded: 'Leído por {n}',
  msgSending: 'Enviando',
  msgSendFail: 'Error al enviar',
  msgRecall: 'Llamar de nuevo',
  msgMenuDelete: 'Eliminar',
  msgMenuRecall: 'Retirar',
  // grabación de voz
  recordTitle: 'Grabación de voz',
  recordDuration: 'Duración',
  recordStart: 'Comenzar',
  recordPause: 'Pausar',
  recordResume: 'Reanudar',
  recordStop: 'Detener',
  recordPlay: 'Reproducir',
  recordStopPlay: 'Detener reproducción',
  recordRestart: 'Grabar de nuevo',
  recordSend: 'Enviar ahora',
  recordStateReady: 'Sin iniciar',
  recordStateRunning: 'Grabando...',
  recordStatePaused: 'Grabación en pausa',
  recordStateStopped: 'Grabación detenida',
  msgReadedTab: 'Leído ({n})',
  msgUnreadTab: 'No leído ({n})',
  // idioma
  langLabel: 'Idioma',
  langZh: '中文',
  langEn: 'English'
}
